import React from "react";
import { createPortal } from "react-dom";
import CloseIcon from "@mui/icons-material/Close";

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  wide?: boolean;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const Drawer: React.FC<DrawerProps> = ({ open, onClose, title, subtitle, wide, children, footer }) => {
  if (!open) return null;

  return createPortal(
    <div className="ds">
      <div className="ds-backdrop" onClick={onClose} />
      <div className={`ds-drawer ${wide ? "wide" : ""}`} role="dialog" aria-modal="true">
        <div className="ds-drawer-head">
          <div>
            <h2>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button type="button" className="ds-icon-btn" onClick={onClose} aria-label="Fechar">
            <CloseIcon fontSize="small" />
          </button>
        </div>
        <div className="ds-drawer-body">{children}</div>
        {footer && <div className="ds-drawer-foot">{footer}</div>}
      </div>
    </div>,
    document.body
  );
};

export default Drawer;
